'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
    'use strict';

    // Usage:
    // 
    // Creates:
    // 

    StreamingDataController.$inject = ['$interval', '$q', '$translate', 'iotService', 'measurementsService', 'settingsService'];
    angular.module('app.iot').component('streamingData', {
        require: { app: '^app' },
        template: '<div style="padding: 2em 0em;"><div class="container-fluid" translate-namespace="iot"><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><ol class="breadcrumb pull-left"><li ng-repeat="breadcrumb in $ctrl.app.breadcrumbs"><a href="{{breadcrumb.url}}">{{breadcrumb.label | translate}}</a></li><li><a ui-sref="iot" translate-namespace="iot" translate>.Urban environment monitoring</a></li><li translate-namespace="iot" translate>.Streaming data</li></ol><div class="pull-right"><login-widget></login-widget></div></div></div><div class="row"><div class="col-xs-12 col-sm-12 col-mg-3 col-lg-3"><aside class="well well-sidebar"><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="btn-group btn-group-justified" style="margin-bottom:1em;" ng-init="category_name_attr = (\'category.name\' | translate)"><label class="btn btn-default" uib-btn-radio="category" ng-repeat="category in $ctrl.form.categoryOptions" ng-model="$ctrl.form.category" ng-click="$ctrl.onCategoryChange()">{{category[category_name_attr]}}</label></div></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12" ng-if="$ctrl.form.category.slug == \'water-resources\'"><div class="alert alert-warning"><i class="fa fa-exclamation-triangle"></i> <span translate>.warning-disclamer</span></div></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="form-group"><label for="timeframe" class="control-label" translate>.Timeframe</label><div class="btn-group btn-group-justified" style="margin-bottom:1em;" ng-init="timeframe_name_attr = (\'timeframe.name\' | translate)"><label class="btn btn-default" uib-btn-radio="timeframe" ng-repeat="timeframe in $ctrl.form.states[$ctrl.form.category.id].timeframeOptions" ng-model="$ctrl.form.states[$ctrl.form.category.id].timeframe" ng-click="$ctrl.onTimeframeChange()">{{timeframe[timeframe_name_attr]}}</label></div></div></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="form-group"><label for="fois" translate>.Locations</label> <small class="pull-right legend-right"><a ng-click="$ctrl.onSelectAllFois()" translate>.Add all</a> - <a ng-click="$ctrl.onRemoveAllFois()" translate>.Remove all</a></small><ui-select id="devices" ng-init="foi_name_attr = (\'foi.name\' | translate)" data-multiple close-on-select="false" search-enabled="false" ng-model="$ctrl.form.states[$ctrl.form.category.id].fois" data-on-select="$ctrl.onFoiSelect($item)" data-on-remove="$ctrl.onFoiRemove($item)" ui-select-placeholder="{{$ctrl.translations[\'iot.Add more locations\']}}" placeholder="{{$ctrl.translations[\'iot.Add more locations\']}}"><ui-select-match placeholder="{{$ctrl.translations[\'iot.Add more locations\']}}"><span class="color-bullet" ng-style="{\'background-color\': $item.color}"></span> <span ng-bind="$item[foi_name_attr]"></span></ui-select-match><ui-select-choices repeat="o in ($ctrl.form.states[$ctrl.form.category.id].foiOptions | orderBy:o[foi_name_attr] | filter: $select.search) track by o.id"><span class="color-bullet" ng-style="{\'background-color\': o.color}"></span> <span ng-bind="o[foi_name_attr]"></span></ui-select-choices></ui-select></div></div></div></aside></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-9"><div class="row"><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6" ng-repeat="modality in $ctrl.form.modalityOptions | orderBy: $ctrl.modalityOrdering"><div class="panel panel-default" ng-init="modality_name_attr = (\'modality.name\' | translate)"><div class="panel-heading">{{modality[modality_name_attr]}} - <small>{{modality.unit}}</small></div><div class="panel-body"><nvd3 id="{{modality.slug}}" options="$ctrl.uiConfig.lineChart.options" config="$ctrl.uiConfig.lineChart.config" data="$ctrl.charts[modality.id].data"></nvd3></div></div></div></div></div></div></div></div>',
        controller: StreamingDataController,
        controllerAs: '$ctrl'
    });

    function StreamingDataController($interval, $q, $translate, iotService, measurementsService, settingsService) {
        'ngInject';

        var $ctrl = this;

        ////////////////

        $ctrl.$onInit = function () {

            $ctrl.form = new FormModel();
            $ctrl.uiConfig = new UiConfig($ctrl.form);
            $ctrl.charts = {};

            $q.all({
                categories: iotService.getCategories(),
                modalities: iotService.getModalities(),
                fois: iotService.getInfrastructure(),
                formDefaults: settingsService.getValue('Visualizer/streamingData/defaults', {}),
                translations: getTranslations()
            }).then(function (r) {
                $ctrl.translations = r.translations;
                $ctrl.modalityOptions = r.modalities;

                $ctrl.form.initialize(r.categories, r.fois, r.modalities);
                $ctrl.form.setDefaults(r.formDefaults);
                $ctrl.onCategoryChange();

                $ctrl.updater = $interval(updateCharts, 60000, 100);
            }).catch(function (error) {
                console.error('Oops! Something went wrong!', error);
            });
        };

        $ctrl.$onDestroy = function () {
            $interval.cancel($ctrl.updater);
        };

        $ctrl.onChangeCategory = function () {};

        /**
         * 
         */
        $ctrl.onCategoryChange = function () {
            $ctrl.charts = {};
            $ctrl.form.modalityOptions.forEach(function (modality) {
                $ctrl.charts[modality.id] = { modality: modality, data: [] };
            });

            updateCharts();
        };

        /**
         * 
         */
        $ctrl.onTimeframeChange = function () {
            updateCharts();
        };

        $ctrl.onSelectAllFois = function () {
            $ctrl.onRemoveAllFois();
            angular.forEach($ctrl.form.foiOptions, function (foi) {
                $ctrl.form.fois.push(foi);
                $ctrl.onFoiSelect(foi);
            });
        };

        $ctrl.onRemoveAllFois = function () {
            angular.forEach($ctrl.form.fois, function (foi) {
                $ctrl.onFoiRemove(foi);
            });
            $ctrl.form.fois = [];
        };

        $ctrl.onFoiSelect = function (foi) {
            angular.forEach(foi.devices, function (device) {
                device.foi = foi;
                addDevice(device);
            });
        };

        $ctrl.onFoiRemove = function (foi) {
            angular.forEach(foi.devices, function (device) {
                device.foi = foi;
                removeDevice(device);
            });
        };

        $ctrl.modalityOrdering = function (modality) {
            return $ctrl.form.category.modality_ids.indexOf(modality.id);
        };

        function updateCharts() {
            angular.forEach($ctrl.form.fois, function (foi) {
                $ctrl.onFoiSelect(foi);
            });
        }

        function addDevice(device) {
            device.modality_ids.forEach(function (modality_id) {
                var modality = _.find($ctrl.form.modalityOptions, { id: modality_id }),
                    to = moment().endOf('minute'),
                    from = to.clone().subtract($ctrl.form.timeframe.hours, 'hours').startOf('minute');

                if (modality) {
                    measurementsService.getDeviceRecords(modality, device, from, to, '1 minute', false, false).then(function (r) {
                        _.remove($ctrl.charts[r.modality.id].data, { id: device.id });

                        $ctrl.charts[r.modality.id].data.push({
                            id: device.id,
                            key: device.foi[$ctrl.translations['foi.name']],
                            color: device.foi.color,
                            values: r.measurements
                        });
                    }).catch(function (error) {
                        console.error('error', error);
                    });
                }
            });
        }

        function removeDevice(device) {
            $ctrl.form.modalityOptions.forEach(function (modality) {
                _.remove($ctrl.charts[modality.id].data, { id: device.id });
            });
        }

        function getTranslations() {
            return $translate(['foi.name', 'timeframe.name', 'iot.Add more locations']);
        }

        var FormModel = function () {
            function FormModel(categories, fois, modalities) {
                _classCallCheck(this, FormModel);

                this.category = undefined;
                this.states = {};
            }

            _createClass(FormModel, [{
                key: 'getter',
                value: function getter(attribute, value) {
                    return this.category ? this.states[this.category.id][attribute] : undefined;
                }
            }, {
                key: 'setter',
                value: function setter(attribute, value) {
                    this.category ? this.states[this.category.id][attribute] = value : undefined;
                }
            }, {
                key: 'initialize',
                value: function initialize(categories, fois, modalities) {
                    this.categoryOptions = categories;
                    this.foiOptions = fois;
                    this.modalityOptions = modality;
                }
            }, {
                key: 'initialize',
                value: function initialize(categories, fois, modalities, granularities) {
                    var _this = this;

                    this.categoryOptions = categories;

                    categories.forEach(function (category) {
                        var colorScale = d3.scale.category10();
                        // var filteredDevices = iotService.filteredDevicesFromFoisByModalityIds(fois, category.modality_ids);
                        var filteredFois = iotService.filterFoisByModalityIds(fois, category.modality_ids);
                        var modalityOptions = iotService.filterModalitiesByIds(modalities, category.modality_ids);

                        // filteredDevices.forEach((o, i) => { o.color = colorScale(i) });
                        filteredFois.forEach(function (o, i) {
                            o.color = colorScale(i);
                        });

                        _this.states[category.id] = {
                            fois: [],
                            // devices         : [],
                            // deviceOptions   : filteredDevices,
                            foiOptions: filteredFois,
                            modalityOptions: modalityOptions,
                            timeframeOptions: getTimeframeOptions(),
                            timeframe: undefined
                        };
                    });
                }
            }, {
                key: 'setDefaults',
                value: function setDefaults(defaultValues) {
                    var _this2 = this;

                    this.category = _.find(this.categoryOptions, { 'id': defaultValues.category });

                    this.categoryOptions.forEach(function (category) {
                        var state = _this2.states[category.id];
                        var defaults = defaultValues.categories[category.id];

                        state.fois = _.filter(state.foiOptions, _.conforms({ id: _.partial(_.includes, defaults.fois) }));
                        state.timeframe = state.timeframeOptions[0];
                    });
                }
            }, {
                key: 'fois',
                get: function get() {
                    return this.getter('fois');
                },
                set: function set(value) {
                    return this.setter('fois', value);
                }
            }, {
                key: 'foiOptions',
                get: function get() {
                    return this.getter('foiOptions');
                },
                set: function set(value) {
                    this.setter('foiOptions', value);
                }
            }, {
                key: 'modalityOptions',
                get: function get() {
                    return this.getter('modalityOptions');
                },
                set: function set(value) {
                    this.setter('modalityOptions', value);
                }
            }, {
                key: 'to',
                get: function get() {
                    return this.getter('to');
                },
                set: function set(value) {
                    this.setter('to', value);
                }
            }, {
                key: 'from',
                get: function get() {
                    return this.getter('from');
                },
                set: function set(value) {
                    this.setter('from', value);
                }
            }, {
                key: 'timeframe',
                get: function get() {
                    return this.getter('timeframe');
                },
                set: function set(value) {
                    this.setter('timeframe', value);
                }
            }]);

            return FormModel;
        }();

        function getTimeframeOptions() {
            return [{ id: 1, name: '1 hour', name_el: '1 ώρα', hours: 1 }, { id: 2, name: '2 hours', name_el: '2 ώρες', hours: 2 }, { id: 3, name: '3 hours', name_el: '3 ώρες', hours: 3 }];
        }

        var LineChartConfig = function () {
            function LineChartConfig() {
                _classCallCheck(this, LineChartConfig);

                this.config = {
                    deepWatchOptions: true,
                    deepWatchData: true,
                    deepWatchDataDepth: 1,
                    debounce: 1000,
                    refreshDataOnly: true
                };

                this.options = {
                    title: { enable: false },
                    subtitle: { enable: false },

                    chart: {
                        type: 'lineChart',
                        showLegend: false,
                        useInteractiveGuideline: true,
                        focusEnable: false,
                        // showVoronoi: true,
                        // useVoronoi: false,
                        // clipVoronoi: false,

                        height: 250,
                        duration: 0,

                        x: function x(d) {
                            return typeof d == 'undefined' ? '' : d.at;
                        },
                        y: function y(d) {
                            return typeof d == 'undefined' ? '' : d.avg;
                        },

                        xScale: d3.time.scale(),
                        xAxis: { tickFormat: d3.time.format('%H:%M') },
                        yAxis: { tickFormat: d3.format(',.1f') },
                        interactiveLayer: {
                            tooltip: {
                                valueFormatter: this.tooltipValueFormatter()
                            }
                        }
                    }
                };
            }

            _createClass(LineChartConfig, [{
                key: 'tooltipValueFormatter',
                value: function tooltipValueFormatter() {
                    var self = this;

                    return function (d, i, entry) {
                        var output = '-';

                        if (!isNaN(d) && d !== null) {
                            output = '' + d3.format(',.2f')(d);
                        }

                        return output;
                    };
                }
            }]);

            return LineChartConfig;
        }();

        var UiConfig = function () {
            function UiConfig(form, measurementsService) {
                _classCallCheck(this, UiConfig);

                this.select2 = { searchEnabled: false };

                this.lineChart = new LineChartConfig();

                // this.lineChart = {

                //     config: {
                //         deepWatchOptions: true,
                //         deepWatchData: true,
                //         deepWatchDataDepth: 1,
                //         debounce: 1000,
                //         refreshDataOnly: true,
                //     },

                //     options: {
                //         title: { enable: false },
                //         subtitle: { enable: false },

                //         chart: {
                //             type: 'lineChart',
                //             showLegend: false,
                //             useInteractiveGuideline: true,
                //             focusEnable: false,
                //             // showVoronoi: true,
                //             // useVoronoi: false,
                //             // clipVoronoi: false,

                //             height: 250,
                //             duration: 0,

                //             x: function (d) { return (typeof d == 'undefined') ? '' : d.at; },
                //             y: function (d) { return (typeof d == 'undefined') ? '' : d.avg; },

                //             xScale: d3.time.scale(),
                //             xAxis: { tickFormat: d3.time.format('%H:%M') },
                //             yAxis: { tickFormat: d3.format(',.1f') },
                //             interactiveLayer: {
                //                 tooltip: {
                //                     valueFormatter: this.tooltipValueFormatter(),
                //                 }
                //             }
                //         },
                //     },


                // }
            }

            _createClass(UiConfig, [{
                key: 'setTranslations',
                value: function setTranslations(i18n) {}
            }]);

            return UiConfig;
        }();
    }
})();